module.exports = __webpack_public_path__ + "img/stage-manager-15.png";